import React from "react";
import "./buildTuatara.css";
import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../../router/router";

const BuildTuatara = () => {
  const navigate = useNavigate();
  return (
    <div
      className={`buildTuatara-bg relative overflow-x-hidden	max-w-[100vw] md:!h-[836px] sm:!h-[717px] !h-[472px] md:px-[100px] px-[0px]`}
    >
      <div className="text-[#F2F2F2CC]  font-bold font-[Rockwell] font-extrabold side-text md:text-[160px] sm:text-[140px] text-[90px] md:leading-[121px] sm:leading-[104px] leading-[65px] build-box">
        TUATARA
      </div>
      <div className="relative custom-container build-box ">
        <div className="build-tuatara-title 2xl:text-[60px] xl:text-[50px] lg:text-[40px] text-[30px] md:pb-[150px] sm:pb-[100px] pb-[40px]">
          BUILT FOR WORK
          <br /> READY FOR ADVENTURE
        </div>
        {/* <div className="flex mt-[31px] md:pb-[150px] sm:pb-[100px] pb-[40px]">
          <button
            className="bg-[#F2F2F2] border-[#5B792E] border-[4px] rounded font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px] text-[#5B792E] lg:px-[150px] md:px-[48px] sm:px-[30px] px-[20px] lg:py-[15px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            onClick={() => navigate(RouterPaths.UtilityVehicles)}
          >
            BUILD MY TUATARA
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default BuildTuatara;
